import ACTIONS from "../constants/actions";

const {
  GET_BRANCH_REQUEST,
  GET_BRANCH_SUCCESS,
  GET_BRANCH_FAIL,
  GET_AUTHORITIES_SUCCESS,
  GET_AUTHORITIES_FAIL,
  GET_AUTHORITIES_REQUEST,
  CHANGE_BRANCH_SUCCESS,
} = ACTIONS;

const initialState = {
  isLoadingGetBranch: false,
  isLoadingGetAuthorities: false,
  branch: [],
  authorities: [],
  changedBranch: false,
};

const branchReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_BRANCH_REQUEST:
      return {
        ...state,
        isLoadingGetBranch: true,
      };
    case GET_BRANCH_SUCCESS:
      return {
        ...state,
        isLoadingGetBranch: false,
        branch: action.payload,
      };
    case GET_BRANCH_FAIL:
      return {
        isLoadingGetBranch: false,
        ...state,
      };
    case GET_AUTHORITIES_REQUEST:
      return {
        ...state,
        isLoadingGetAuthorities: true,
      };
    case GET_AUTHORITIES_SUCCESS:
      return {
        ...state,
        isLoadingGetAuthorities: false,
        authorities: action.payload,
      };
    case CHANGE_BRANCH_SUCCESS:
      return {
        ...state,
        // isLoadingGetAuthorities: false,
        // authorities: action.payload,
        changedBranch: true,
      };
    case GET_AUTHORITIES_FAIL:
      return {
        ...state,
        isLoadingGetAuthorities: false,
      };
    default:
      return state;
  }
};
export default branchReducer;
